// @ts-nocheck
import React from 'react'
import { inject, observer } from 'mobx-react'
import DealsSection from './DealsSection'
import SimpleCarousel from '../../../components/common/SimpleCarousel'
import LTOCard from './LTOCard'
import styled from 'styled-components'
import { respondAbove } from '../../../styles/mixins'
import { codeToLocale, getTranslatedTextByKey } from '../../../utils/utils'
import PropTypes from 'prop-types'
import { OrderType } from 'shared-types/Coupon'

const StyledSimpleCarousel = styled(SimpleCarousel)`
	margin: -30px -20px;

	${respondAbove.md`
        margin: -30px 0;
    `}
`

const LimitedTimeOffersSection = inject(
	'User',
	'Infra'
)(
	observer(({ items, offerType, onLimitedTimeOfferClick, User, Infra }) => {
		const hidePriceForUnlocalizedItem = Infra.appParams?.features?.hidePriceForUnlocalizedItem

		const isDeliveryType = offerType === OrderType.DELIVERY

		const titlePath = isDeliveryType ? 'eCommerce.deals.limitedOffersForDelivery' : 'eCommerce.deals.limitedOffersForPickup'
		const titleFallback = isDeliveryType ? 'Delivery Deals' : 'Pickup Deals'
		const title = getTranslatedTextByKey(titlePath, titleFallback)

		return (
			<DealsSection title={title} testId={isDeliveryType ? 'delivery-deals-title' : 'pickup-deals-title'}>
				<StyledSimpleCarousel>
					{items.map((item, index) => (
						<LTOCard
							data-testid={`${offerType}-card-${index}`}
							key={item.id}
							item={item}
							locale={codeToLocale[User.preferredLanguage] ?? 'en_US'}
							currency={Infra.appParams.currency}
							hidePriceForUnlocalizedItem={hidePriceForUnlocalizedItem}
							onClick={() => onLimitedTimeOfferClick(item, isDeliveryType ? OrderType.DELIVERY : OrderType.PICKUP)}
						/>
					))}
				</StyledSimpleCarousel>
			</DealsSection>
		)
	})
)

LimitedTimeOffersSection.propTypes = {
	items: PropTypes.arrayOf(PropTypes.object).isRequired,
	offerType: PropTypes.oneOf(['delivery', 'pickup']).isRequired,
	onLimitedTimeOfferClick: PropTypes.func.isRequired,
}

export default LimitedTimeOffersSection
